import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import LandingLayout from 'src/components/Layouts/LandingLayout';
import PageLoader from 'src/components/Loader/PageLoader';
import AuthProvider from 'src/contexts/AuthContext';
// import useAuth from 'src/hooks/useAuth';

const PublicRoutes = () => {
  // const { isAuthenticated } = useAuth();

  return (
    <LandingLayout>
      <Suspense fallback={<PageLoader />}>
        <Outlet />
      </Suspense>
    </LandingLayout>
  );
};

const Page = () => (
  <AuthProvider>
    <PublicRoutes />
  </AuthProvider>
);

export default Page;
